import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import EnvelopeUpgrade from "./partials/EnvelopeUpgrade";
import UseTemplate from "./UseTemplate";
import { Lang } from "../../lang";
import Utils from '../../utils';
import useDocumentCounts from "./Envelope/Manage/useDocumentCounts";
import { envelopeLeft } from "../../services/CommonService";
import Dashboard from "./Dashbourd";


function Home() {

    document.title = Lang.homepage_title;
    document.getElementsByTagName("META")[4].content = Lang.homepage_meta_desc;
    document.getElementsByTagName("META")[5].content = Lang.homepage_meta_keyword;

    // Add compact home CSS
    useEffect(() => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = '/css/compact-home.css';
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, []);

    const [isUseTemplate, setIsUseTemplate] = useState(false);
    const navigate = useNavigate();
    const userData = Utils.loginUserData();
    const userEmail = userData?.email || "";
    const userId = userData?.id || null;
    const [dataParams] = useState({});
    const {
        counts: { totalFiles = 0, totalInProgress = 0, totalCompleted = 0 },
    } = useDocumentCounts({ userEmail, userId, dataParams });
    const [totalEnvelope, setTotalEnvelope] = useState(0);
    const [planName, setPlanName] = useState('Free Trial');

    useEffect(() => {
        envelopeLeft({})
            .then(response => {
                setPlanName(response.data.data.plan_name);
                setTotalEnvelope(response.data.data.total_envelope);
            })
            .catch(() => { });
    }, []);

    function onEnvelopeStart(e) {
        e.preventDefault();
        navigate("/client-portal/sleeve");
    }
    function onRedirectRecipient(e) {
        e.preventDefault();
        navigate("/recipients");
    }
    function onSmartquestionnaireStart(e) {
        e.preventDefault();
        navigate("/client-portal/smart-questionnaire");
    }

    const handleUseTemplate = (e) => {
        e.preventDefault();
        setIsUseTemplate(true);
    };

    return (
        <>
            <section className="compact-home-wrapper min-height-sleeve" style={{paddingTop:"85px"}}>
                <div className="container-fluid px-4">
                    <div className="custom_container">
                        <div className="row g-3 mb-2">
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12" onClick={onRedirectRecipient}>
                                <div className="mini-action-card clickable">
                                    <div className="mini-icon-wrapper">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                            <rect width="24" height="24" rx="6" fill="#6366f1" />
                                            <path d="M12 7v10M7 12h10" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                        </svg>
                                    </div>
                                    <div className="mini-card-content">
                                        {/* <h4 className="mini-card-title">New</h4> */}
                                        <span className="mini-card-action fs-5">Create Recipient</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12" onClick={onEnvelopeStart}>
                                <div className="mini-action-card clickable">
                                    <div className="mini-icon-wrapper">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                            <rect width="24" height="24" rx="6" fill="#6366f1" />
                                            <path d="M12 7v10M7 12h10" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                        </svg>
                                    </div>
                                    <div className="mini-card-content">
                                        {/* <h4 className="mini-card-title">New</h4> */}
                                        <span className="mini-card-action fs-5">Create Sleeve</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12" onClick={onSmartquestionnaireStart}>
                                <div className="mini-action-card clickable">
                                    <div className="mini-icon-wrapper">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                            <rect width="24" height="24" rx="6" fill="#6366f1" />
                                            <path d="M12 7v10M7 12h10" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                        </svg>
                                    </div>
                                    <div className="mini-card-content">
                                        {/* <span className="mini-card-action">Create</span> */}
                                        <span className="mini-card-action fs-5">Create Questionnaire</span>
                                        {/* <h4 className="mini-card-title">Questionnaire</h4> */}
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12" onClick={handleUseTemplate} data-bs-toggle="offcanvas" data-bs-target="#useTemplate">
                                <div className="mini-action-card clickable">
                                    <div className="mini-icon-wrapper">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                            <rect width="24" height="24" rx="6" fill="#6366f1" />
                                            <rect x="8" y="6" width="8" height="12" rx="1" fill="none" stroke="white" strokeWidth="1.5" />
                                            <path d="M10 9h4M10 12h4M10 15h2" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                                        </svg>
                                    </div>
                                    <div className="mini-card-content" data-bs-toggle="offcanvas" data-bs-target="#useTemplate">
                                        {/* <h4 className="mini-card-title">Template</h4> */}
                                        <span className="mini-card-action fs-5">Use Template</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12" onClick={() => navigate('/billing/pricing')}>
                                <div className="mini-stats-card clickable">
                                    <div className="stats-header">
                                        <span className="plan-badge">{planName}</span>
                                        <svg width="16" height="16" fill="#6366f1" viewBox="0 0 24 24">
                                            <path d="M3 17h2v-7H3v7zm4 0h2v-3H7v3zm4 0h2v-10h-2v10zm4 0h2v-5h-2v5zm4 0h2v-2h-2v2z" />
                                        </svg>
                                    </div>
                                    <div className="status-bar-home">
                                        <div className="stats-number">{totalEnvelope}</div>
                                        <div className="stats-label">Sleeve Left</div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12" onClick={(e) => navigate('/manage/files')}>
                                <div className="mini-action-card clickable">
                                    <div className="mini-icon-wrapper">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                            <rect width="24" height="24" rx="6" fill="#6366f1" />
                                            <path d="M6 18C5.5 18 5.5 17.5 5.5 17.5V9.5C5.5 9 6 9 6 9H10L11 10.5H17.5C18 10.5 18 11 18 11V17.5C18 18 17.5 18 17.5 18H6Z" fill="white" />
                                        </svg>
                                    </div>
                                    <div className="mini-card-content">
                                        {/* <h4 className="mini-card-title">Files</h4> */}
                                        <span className="mini-card-action fs-5">Sleeve Files</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12" onClick={(e) => navigate('/manage/my-files')}>
                                <div className="mini-action-card clickable">
                                    <div className="mini-icon-wrapper">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                            <rect width="24" height="24" rx="6" fill="#6366f1" />
                                            <path d="M12 17.5L7.5 19.5L8.5 14.5L5 11L10 10.5L12 6L14 10.5L19 11L15.5 14.5L16.5 19.5L12 17.5Z" stroke="white" strokeWidth="1.5" fill="none" />
                                        </svg>
                                    </div>
                                    <div className="mini-card-content">
                                        {/* <h4 className="mini-card-title">My Files</h4> */}
                                        <span className="mini-card-action fs-5">My Files</span>
                                    </div>
                                </div>
                            </div>
                            {/* 
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="mini-analytics-card">
                                <div className="analytics-icon">
                                    <svg width="16" height="16" fill="#6366f1" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="8" stroke="#6366f1" strokeWidth="2" fill="none" />
                                        <path d="M12 8v4l2 2" stroke="#6366f1" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <div className="analytics-grid">
                                    <div className="analytics-item">
                                        <span className="analytics-number">{totalInProgress}</span>
                                        <span className="analytics-label">Active</span>
                                    </div>
                                    <div className="analytics-item">
                                        <span className="analytics-number">{totalCompleted}</span>
                                        <span className="analytics-label">Done</span>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                            {/* <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12" onClick={onSmartquestionnaireStart}>
                            <div className="mini-action-card clickable">
                                <div className="mini-icon-wrapper">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                        <rect width="24" height="24" rx="6" fill="#6366f1" />
                                        <path d="M12 7v10M7 12h10" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <div className="mini-card-content">
                                    <span className="mini-card-action">Create</span>
                                    <h4 className="mini-card-title">Questionnaire</h4>
                                </div>
                            </div>
                        </div> */}

                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12" onClick={(e) => navigate('/client-portal/smart-questionnaire/manage')}>
                                <div className="mini-action-card clickable">
                                    <div className="mini-icon-wrapper">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                            <rect width="24" height="24" rx="6" fill="#6366f1" />
                                            <rect x="8" y="9" width="8" height="1.5" rx="0.5" fill="white" />
                                            <rect x="8" y="12" width="6" height="1.5" rx="0.5" fill="white" />
                                            <rect x="8" y="15" width="4" height="1.5" rx="0.5" fill="white" />
                                        </svg>
                                    </div>
                                    <div className="mini-card-content">
                                        {/* <h4 className="mini-card-title">Manage</h4> */}
                                        <span className="mini-card-action fs-5">Manage Questionnaire</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Dashboard />
            </section >
            <UseTemplate isUseTemplate={isUseTemplate} setIsUseTemplate={setIsUseTemplate} />
        </>
    );
}

export default Home;
